import type { DataRoomFileTreeNode, DataRoomFileTreeVisibleRow } from "./types";

type UseVisibleDataRoomRowsParams<TNode extends DataRoomFileTreeNode> = {
  nodeMap: Record<string, TNode | undefined>;
  rootIds: string[];
  collapsedIds: Set<string>;
  hiddenIds?: Set<string>;
};

export function useVisibleDataRoomRows<TNode extends DataRoomFileTreeNode>({
  nodeMap,
  rootIds,
  collapsedIds,
  hiddenIds,
}: UseVisibleDataRoomRowsParams<TNode>): DataRoomFileTreeVisibleRow<TNode>[] {
  const rows: DataRoomFileTreeVisibleRow<TNode>[] = [];

  function walk(nodeId: string, depth: number) {
    const node = nodeMap[nodeId];

    if (!node || hiddenIds?.has(nodeId)) return;

    rows.push({ ...node, depth });

    if (node.type === "folder" && !collapsedIds.has(nodeId)) {
      node.children.forEach((childId) => walk(childId, depth + 1));
    }
  }

  rootIds.forEach((rootId) => walk(rootId, 0));

  return rows;
}
